import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import api from '../services/api';

// The SIM inventory. staleTime 0 because this screen exists to be edited, and a
// stale list is how two people end up holding one SIM.
export function useSims() {
  return useQuery({
    queryKey: ['sims'],
    queryFn: async () => {
      const { data } = await api.get('/api/sims');
      return data;
    },
    staleTime: 0,
    retry: false,
  });
}

// Every mutation invalidates the directory too — it reads its contact number
// from this same table, so its cached copy is wrong the moment a SIM moves.
function useSimMutation(mutationFn) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['sims'] });
      queryClient.invalidateQueries({ queryKey: ['directory'] });
    },
  });
}

export function useAddSim() {
  return useSimMutation(async (sim) => (await api.post('/api/sims', sim)).data);
}

export function useUpdateSim() {
  return useSimMutation(async ({ id, ...body }) => (await api.put(`/api/sims/${id}`, body)).data);
}
